import axios from "axios";
import { createAppTransport } from "@1823-partners/core";

// createAppTransport picks proxy mode in production (same-origin /api/<slug>)
// and direct mode (pam.wsq.io) in dev/test. Direct mode reads creds from
// REACT_APP_BEACON_* env vars in .env.local — no JSON imports.
const api = createAppTransport({ axios, appName: "relval" });

export const getRelValDates = () => api.get("/relval-dates");

export const getRelValAssumptions = () => api.get("/relval-assumptions");

export const getRelValUstCurve = (asofdt) =>
  asofdt
    ? api.get(`/relval-ust-curve?asofdt=${asofdt}`)
    : api.get("/relval-ust-curve");

// The SOFR curve is uploaded with the Asset Menu rather than read from
// USD_CMT, so it has its own endpoint alongside the UST strip.
export const getRelValSofrCurve = (asofdt) =>
  asofdt
    ? api.get(`/relval-sofr-curve?asofdt=${asofdt}`)
    : api.get("/relval-sofr-curve");

export const getRelValData = (asofdt) =>
  asofdt ? api.get(`/relval-data?asofdt=${asofdt}`) : api.get("/relval-data");

export const saveRelValData = (data) => api.post("/save-relval", data);

export const saveAssetMenuData = (data) => api.post("/save-asset-menu", data);

export const saveRelValSourceData = (data) =>
  api.post("/save-relval-source", data);

// UI hint only — the server enforces every gate via @require_permission.
// The Save button needs 'relval.data:write'.
export const getMyPermissions = () => api.get("/my-permissions");

export default api;
